import {
	CLEAR_GIFTS,
	FETCH_GIFTS_FAILED,
	FETCH_GIFTS_SUCCEEDED,
	GET_GIFTS,
	SET_SORT_BY,
} from './gifts.action';
import { clone, pathOr, path } from 'ramda';
import { giftsInitialState } from './gifts.initialState';

export const giftReducer = (state = giftsInitialState, action) => {
	switch (action.type) {
		case CLEAR_GIFTS: {
			return {
				...state,
				...giftsInitialState,
				// persist the sortBy selection
				sortBy: state.sortBy,
			};
		}

		case FETCH_GIFTS_SUCCEEDED: {
			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			const newTotal = path(['payload', 'total'], action);
			const newSkip =
				newTotal >= state.skip ? { skip: action.payload && action.payload.skip + 10 } : {};

			return {
				...state,
				entities,
				pendingFetch: false,
				totalToDisplay: newTotal,
				...newSkip,
			};
		}

		case GET_GIFTS: {
			return { ...state, pendingFetch: true };
		}

		case FETCH_GIFTS_FAILED: {
			return { ...state, pendingFetch: false, fetchError: true, errorType: action.payload };
		}

		case SET_SORT_BY: {
			return {
				...state,
				sortBy: action.payload.sortValue,
			};
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/gifts/gifts.reducer.js